import { widgetApi } from "../services/api";
import { getAnalyticsSession } from "./posthog";

export async function reportAnalyticsSession(params: {
  linkId: string;
  distinctId: string;
  sessionId: string;
  windowId?: string;
}): Promise<void> {
  try {
    await widgetApi.post(
      `/widget/links/${params.linkId}/analytics-session`,
      {
        distinctId: params.distinctId,
        sessionId: params.sessionId,
        ...(params.windowId ? { windowId: params.windowId } : {}),
      },
    );
  } catch {
    /* swallow — telemetry must never break the UI */
  }
}

/** Fire-and-forget handshake when PostHog has an identified session. */
export function maybeReportAnalyticsSession(linkId: string | undefined | null): void {
  if (!linkId) return;
  const { distinctId, sessionId, windowId } = getAnalyticsSession();
  if (!distinctId || !sessionId) return;
  void reportAnalyticsSession({ linkId, distinctId, sessionId, windowId });
}
